import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=0ec71a07&scoped=true"
import script from "./confirm-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec71a07",
  null
  
)

export default component.exports